import * as Yup from 'yup';

export const firstName = Yup.string()
  .trim()
  .max(20, 'First name should be less than 20 symbols')
  .required('First name is required');
